import React, { memo, useEffect } from "react";
import { Score } from "@t8891/mobile";
import { CaretRightOutlined } from "@ant-design/icons";
import { setUrlFormat } from "@Lib/common";

const KindSumScore: React.FC<{
  dataSource: {
    count: number;
    score: number;
    brandName: string;
    kindName: string;
  };
}> = ({ dataSource }) => {
  const { count, score, brandName, kindName } = dataSource;
  useEffect(() => {}, []);

  return (
    <a
      href={`/${setUrlFormat(brandName)}/${setUrlFormat(kindName)}/Comment.html`}
      target='_blank'
      className={"w-282 h-72 bg-[#fff] rounded-4 py-8 px-12 flex flex-col mt-10"}
      style={{ boxShadow: "0px 4px 20px 0px rgba(50,100,255,0.10)" }}
    >
      <div className='flex justify-between items-center '>
        <h3 className='text-16 text-[#333] leading-20'>車友交流</h3>
        <div className='flex justify-center items-center' id='ExchangeMore'>
          <span className='text-[#999999] text-12 mr-4'>共{!!count ? count : "--"}條</span>
          <CaretRightOutlined style={{ color: "#333", fontSize: "10px" }} />
        </div>
      </div>

      {!!count ? (
        <div className='flex justify-start items-center mt-8'>
          <Score width={"24px"} score={dataSource?.score ? Number(score) : 0} color='#F7B500' />
          <span className='text-[#333333] text-14 ml-12'>{score.toFixed(2)}分</span>
        </div>
      ) : (
        <span className='text-14 text-[#666666] mt-12 leading-20'>暫無評分</span>
      )}
    </a>
  );
};

export default memo(KindSumScore);
